import { Toast } from "iq-blueberry"

// Hooks
import useGlobalError from "./hook"
// Styles
import * as S from "./styles.js"

const GlobalError = () => {
  const { closeToast, isOpenToast, message } = useGlobalError()

  return (
    <div css={S.GlobalErrorContainer}>
      <Toast
        close={closeToast}
        isVisible={isOpenToast}
        type="error"
        text={message}
      />
    </div>
  )
}

export default GlobalError
